var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.086 4.188c0-.282.246-.563.562-.563.281 0 .563.281.563.563v4.78l3.093 2.075c.282.176.352.527.176.773-.176.282-.527.352-.773.176l-3.375-2.25a.56.56 0 0 1-.282-.492zM9.648.25c4.957 0 9 4.043 9 9 0 4.992-4.043 9-9 9-4.992 0-9-4.008-9-9 0-4.957 4.008-9 9-9m-7.875 9a7.86 7.86 0 0 0 7.875 7.875c4.324 0 7.875-3.516 7.875-7.875 0-4.324-3.55-7.875-7.875-7.875-4.36 0-7.875 3.55-7.875 7.875"
  })));
};
export default SvgClock;